const vocab = {
  cluster_name: {
    sdi: 'Datahub datasets',
  },
};

const vocabWrapper = { vocab };

export default vocabWrapper;
